/**
 *  Terms script file
**/

export default {
  name: 'Terms',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      selfUrl: window.location.origin
    }
  },
  computed: {
  },
  methods: {
  }
}
